import DOMPurify from "dompurify";
import { Envelope, X } from "@phosphor-icons/react";

/**
 * Modal that shows a WYSIWYG preview of the manager's Monday-morning
 * leave digest email. HTML comes from the server; we still run it
 * through DOMPurify defensively in case future fields inject
 * user-controlled text (employee names, department labels, etc.).
 */
export default function DigestPreviewModal({ html, onClose, onSendMe, sending, title = "Your next Monday email", eyebrow = "SMARTERP / DIGEST PREVIEW" }) {
  return (
    <div
      className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-start justify-center pt-6 px-4"
      data-testid="digest-preview-modal"
      onClick={onClose}
    >
      <div
        className="bg-white border border-zinc-950 w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-zinc-950 text-white px-4 py-2.5 flex items-center justify-between">
          <div>
            <div className="font-mono text-[10px] tracking-[0.2em] text-[#FF3E00]">{eyebrow}</div>
            <div className="text-sm font-bold">{title}</div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={onSendMe}
              disabled={sending}
              data-testid="digest-send-me-btn"
              className="font-mono text-[10px] tracking-[0.15em] uppercase bg-[#FF3E00] text-white px-3 py-1.5 hover:bg-white hover:text-zinc-950 disabled:opacity-40 flex items-center gap-1.5"
            >
              <Envelope size={11} weight="fill" />
              {sending ? "SENDING…" : "EMAIL ME THIS"}
            </button>
            <button
              onClick={onClose}
              data-testid="digest-preview-close"
              className="text-white/70 hover:text-white"
            ><X size={18} /></button>
          </div>
        </div>
        <div
          className="flex-1 overflow-y-auto p-6 bg-zinc-50"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(html, {
              ALLOWED_TAGS: ["div", "p", "b", "i", "em", "strong", "span", "a", "table", "thead", "tbody", "tr", "th", "td", "br", "h2", "h3"],
              ALLOWED_ATTR: ["style", "href", "target", "rel"],
            }),
          }}
        />
      </div>
    </div>
  );
}
